var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.989,
    height: 23.833,
    viewBox: "0 0 22.989 23.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3838",
    "data-name": "\\uD328\\uC2A4 3838",
    d: "M305.37,51.238c-.177-.077-.357-.143-.537-.2a6.179,6.179,0,1,0-3.689-.01,6.005,6.005,0,0,0-3.689,3.306,5.866,5.866,0,0,0-3.57-3.04,6.153,6.153,0,0,0,3.9-1.729,7.235,7.235,0,0,1-.749-1.183,4.818,4.818,0,1,1,0-6.487,7.2,7.2,0,0,1,.75-1.182,6.175,6.175,0,1,0-6.109,10.331h-3.915L286.19,62.79h2.766v0h3.17v-.011h.075a5.851,5.851,0,0,0,5.324-3.436,6.015,6.015,0,0,0,7.692,3.015l-.486-1.234a4.7,4.7,0,0,1-5.343-7.4l7.431,6.472.651.583a6.031,6.031,0,0,0-2.1-9.533ZM292.2,61.625a4.706,4.706,0,1,1,4.706-4.706A4.706,4.706,0,0,1,292.2,61.625Zm5.984-16.491A4.818,4.818,0,1,1,303,49.953,4.818,4.818,0,0,1,298.185,45.135Zm9.092,13.5c-.044.1-.091.2-.142.3l-6.892-6a4.7,4.7,0,0,1,7.034,5.705Z",
    transform: "translate(-286.19 -38.958)",
    fill: "#00ffce"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwcLogo);
export default __webpack_public_path__ + "static/media/pwc-logo.fb5e1c6f.svg";
export { ForwardRef as ReactComponent };